import {Button, TablePagination} from '@material-ui/core';
import {FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage} from '@material-ui/icons';
import messages from '@super-template/messages';
import {FormattedMessage, useIntl} from "react-intl";
import {useQueryParams} from 'use-query-params';
import {filterModel} from '../../utils';

export default function Pagination({pagination}) {
  const [query, setQuery] = useQueryParams(filterModel);
  const setNewProps = (newProps) => setQuery({...query, page: newProps.page});

  return (
    <TablePagination
      component={"div"}
      rowsPerPageOptions={[pagination.pageSize]}
      count={pagination.count}
      rowsPerPage={pagination.pageSize}
      page={pagination.page - 1}
      labelDisplayedRows={({from, to, count}) =>
        <FormattedMessage {...messages.displayed_rows} values={{count: count, from: from, to: to}}/>}
      onPageChange={(event, page) => setNewProps({page: page + 1})}
      ActionsComponent={TablePaginationActions}
    />
  );
};

const getPageArr = (last) => [last - 4, last - 3, last - 2, last - 1, last];

function TablePaginationActions({count, page, rowsPerPage: pageSize, onPageChange: onChange}) {
  const pageCount = Math.ceil(count / pageSize);
  const intl = useIntl();
  let arr;
  if (pageCount > 7) arr = page < 4 ? [...Array(5).keys()] : getPageArr((page + 2 >= pageCount) ? pageCount : page + 2);
  else arr = [...Array(pageCount).keys()];

  return (
    <div className={"button-container"}>
      <Button onClick={(e) => onChange(e, 0)} disabled={page === 0}
              aria-label={intl.formatMessage(messages.first_page)}>
        <FirstPage/>
      </Button>
      <Button onClick={(e) => onChange(e, page - 1)} disabled={page === 0}
              aria-label={intl.formatMessage(messages.prev_page)}>
        <KeyboardArrowLeft/>
      </Button>
      {arr.map(num =>
        <Button key={num} variant={`${page === num ? "contained" : "outlined"}`} color="primary"
                onClick={(e) => onChange(e, num)}>{num + 1}</Button>)}
      <Button onClick={(e) => onChange(e, page + 1)} disabled={page >= Math.ceil(count / pageSize) - 1}
              aria-label={intl.formatMessage(messages.next_page)}>
        <KeyboardArrowRight/>
      </Button>
      <Button onClick={(e) => onChange(e, Math.max(0, pageCount - 1))}
              disabled={page >= pageCount - 1} aria-label={intl.formatMessage(messages.last_page)}>
        <LastPage/>
      </Button>
    </div>
  );
}
